export default __webpack_public_path__ + "static/media/chainalysis-logo.35f5850d.svg";